import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserRegistrationService } from '../../../services/user-registration.service';
import { ResendCodeCallback } from '../../../services/cognito.service';
import { ApplicationDataService } from 'services/application.service';
import { ErrorService } from 'services/error.service';

@Component({
  selector: 'app-resend',
  templateUrl: './resend.component.html',
  styleUrls: ['./resend.component.css']
})
export class ResendComponent implements ResendCodeCallback, OnInit {
  email: string;

  constructor(public registrationService: UserRegistrationService, public router: Router, private applicationService: ApplicationDataService, private errorService: ErrorService) { }

  ngOnInit() {
  }

  onSubmit() {
    this.applicationService.getCaseCorrectEmail(this.email).subscribe(res => this.onEmailCheckResponse(res));
  }

  onEmailCheckResponse(caseCorrectEmail: string) {
    if(caseCorrectEmail) {
      this.registrationService.resendCode(caseCorrectEmail, this);
    }
    else {
      this.registrationService.resendCode(this.email, this);
    }    
  }

  resendCodeCallback(error: any, result: any) {
    if (error != null) {
        this.errorService.showError(error);
    } else {
        this.errorService.showMessage("Code sent. Please check your email.");
        this.router.navigate(['/public/register/confirm', this.email]);
    }
  }
}
